import React from 'react';
import Modal from './Modal';
import RichTextEditor, { createValueFromString } from 'react-rte';
import { RTE_DEFAULT_TOOLBAR_CONFIG } from '../../const';

class TextAreaModal extends React.Component {
  state = {
    text: createValueFromString('', 'html')
  };

  render() {
    const { isOpen, closeModal, title, submitLabel = 'Save' } = this.props;
    const { text } = this.state;
    return (
      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <div className="admin-wrapper">
          <h2 className="h2 cms__section-head">{title}</h2>

          <RichTextEditor
            value={text}
            onChange={this.handleChange}
            className="text-area text-area--edit"
            toolbarConfig={RTE_DEFAULT_TOOLBAR_CONFIG}
            autoFocus={true}
          />

          <div className="form__row">
            <div className="form__row-item--half">
              <div
                className="btn btn--hollow-red-bright btn--full-width"
                onClick={closeModal}
              >
                Cancel
              </div>
            </div>
            <div className="form__row-item--half">
              <div
                className="btn btn--solid-blue btn--full-width"
                onClick={this.onSubmit}
              >
                {submitLabel}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  handleChange = text => {
    this.setState({ text });
  };

  onSubmit = () => {
    let text = this.state.text.toString('html');
    //set to empty
    text = text === '<p><br></p>' ? '' : text;
    this.props.onSubmit(text);
  };

  componentDidMount() {
    // initialize state from props
    this.setState({
      text: createValueFromString(this.props.value || '', 'html')
    });
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.value !== prevProps.value)
      this.setState({
        text: createValueFromString(this.props.value || '', 'html')
      });
  }
}

export default TextAreaModal;



// WEBPACK FOOTER //
// ./src/components/shared/TextAreaModal.js